export default __webpack_public_path__ + "static/media/share.162c33ae.svg";